/* variant-popup.js — Popup de choix de formule (1/2/3 flacons) sur les grilles de collection.
 *
 * Historique du bug corrigé : le popup était piloté par un <script> inline rendu dans
 * chaque carte produit (snippet variant-popup.liquid). Avec le scroll infini (Ajaxinate),
 * le HTML des pages suivantes est injecté via insertAdjacentHTML : les <script> inline
 * ne sont PAS exécutés, donc window['openVariantPopup_<id>'] n'existait pas pour les
 * produits chargés au scroll => le bouton "Ajouter au panier" ne faisait rien.
 *
 * Solution : délégation d'événements sur document (une seule fois, fonctionne pour tout
 * élément injecté dynamiquement) + ouverture par data attribute sur le bouton.
 */
(function () {
  'use strict';

  function findPopup(productId) {
    return document.getElementById('VariantPopup-' + productId);
  }

  function openPopup(popup) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }
    popup.classList.remove('closing');
    popup.style.display = 'flex';
    // Force un reflow pour permettre la transition
    void popup.offsetWidth;
    popup.classList.add('open');
    // Réinitialiser les boutons
    popup.querySelectorAll('.variant-option-button').forEach(function (btn) {
      btn.classList.remove('added');
    });
  }

  function closePopup(popup) {
    popup.classList.add('closing');
    popup.classList.remove('open');
    // Attendre la fin de la transition puis masquer
    setTimeout(function () {
      popup.style.display = 'none';
      popup.classList.remove('closing');
    }, 300); // durée identique à la transition CSS
  }

  function updateCartBadge(count) {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;
    var span = bubble.querySelector('span[aria-hidden]');
    if (span) span.textContent = count;
    bubble.setAttribute('data-cart-count', count);
    bubble.classList.toggle('hidden', count == 0);
  }

  function refreshCartDrawer() {
    fetch('/cart?section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('CartDrawer');
        var existingDrawer = document.getElementById('CartDrawer');
        if (!existingDrawer || !newDrawer) return;

        existingDrawer.innerHTML = newDrawer.innerHTML;

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
        }

        var closeButtons = document.querySelectorAll('#CartDrawer .drawer__close');
        closeButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (cartDrawer) cartDrawer.close();
          });
        });

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  /* Repli si <cart-drawer> n'est pas encore defini comme custom element :
     on injecte les sections renvoyees par /cart/add.js puis on ouvre le drawer. */
  function applyCartSections(state, sections) {
    if (!state || !state.sections) return;
    var parser = new DOMParser();
    sections.forEach(function (id) {
      var html = state.sections[id];
      if (!html) return;
      var doc = parser.parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.shopify-section') || doc.body;
      var current = document.getElementById(id);
      if (!current) return;
      current.innerHTML = fresh.innerHTML;
      current.classList.remove('hidden');
      current.removeAttribute('hidden');
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
    }
  }

  function addToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (btn.dataset.available !== 'true') return;

    btn.classList.add('added');

    var cartDrawer = document.querySelector('cart-drawer');
    /* On demande les sections : sans elles, renderContents() ne peut rien rendre
       (drawer vide) et le badge du panier ne se met pas a jour. */
    var sections = ['cart-drawer', 'cart-icon-bubble'];

    var payload = {
      id: variantId,
      quantity: 1,
      sections: sections,
      sections_url: window.location.pathname
    };
    if (btn.dataset.sellingPlan) {
      payload.selling_plan = parseInt(btn.dataset.sellingPlan, 10);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state && state.status) {
          throw new Error(state.description || state.message || 'Ajout impossible');
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          /* Sequence Dawn complete : retirer is-empty (racine + .drawer__inner)
             PUIS renderContents, qui remplit le drawer, met a jour le badge
             du panier et OUVRE le panier lateral. */
          cartDrawer.classList.remove('is-empty');
          var inner = cartDrawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          cartDrawer.renderContents(state);
        } else {
          applyCartSections(state, sections);
        }

        var popup = btn.closest('.variant-popup-overlay');
        if (popup) {
          // Fermeture avec fondu apres un court delai pour voir l'animation
          setTimeout(function () {
            closePopup(popup);
          }, 600);
        }
      })
      .catch(function (error) {
        console.error('Erreur ajout panier:', error);
        btn.classList.remove('added');
      });
  }

  // ---- Délégation : fonctionne aussi pour les produits chargés par Ajaxinate ----
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // 1. Bouton "Ajouter au panier" (ouvre le popup de choix de formule)
    var opener = target.closest('[data-variant-popup-id]');
    if (opener) {
      var popup = findPopup(opener.getAttribute('data-variant-popup-id'));
      if (popup) openPopup(popup);
      return;
    }

    // 2. Bouton de fermeture (✕)
    var closeBtn = target.closest('.variant-popup__close');
    if (closeBtn) {
      var overlay = closeBtn.closest('.variant-popup-overlay');
      if (overlay) closePopup(overlay);
      return;
    }

    // 3. Clic sur le fond de l'overlay
    if (target.classList && target.classList.contains('variant-popup-overlay')) {
      closePopup(target);
      return;
    }

    // 4. Choix d'une formule dans le popup (ajout au panier)
    var optionBtn = target.closest('.variant-option-button');
    if (optionBtn) {
      addToCart(optionBtn);
      return;
    }
  });
})();
